export default __webpack_public_path__ + "static/media/img-14-cedar.38195cd5.jpg";